var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-action',[(_vm.item.connected)?_c('v-icon',{attrs:{"color":"success","small":""}},[_vm._v("mdi-check")]):_c('v-btn',{attrs:{"color":"secondary","x-small":"","loading":_vm.loading},on:{"click":function($event){return _vm.connect(_vm.item)}}},[_vm._v("Connect")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }